import React, { useState, useRef, useEffect } from 'react'
import FormGroup from 'react-bootstrap/lib/FormGroup';
import ApiActions from '../../../actions/ApiActions.jsx'
import Select, { components } from 'react-select';
import moment from 'moment'
import { ToastContainer } from "react-toastify";
import DropdownButton from 'react-bootstrap/lib/DropdownButton';
import MenuItem from 'react-bootstrap/lib/MenuItem';
//custom imports
import FrappButton from '../../../components/utilities/FrappButton.jsx';
import { PlusIcon, DeleteIcon } from '../../../assets/images/index.js'
import styles from '../../../assets/stylesheets/pages/project/project.module.scss'
import { getProjectReports } from './service.js'
import Datepicker from '../../../uicomponents/date-picker/datepicker.jsx';
import emailHelper from '../../../helper/email.js';
import Table from '../../../uicomponents/table/Table.jsx';
import jwt_decode from "jwt-decode";
import { defaultTheme } from "react-select";
const { colors } = defaultTheme;

// Report types configuration
const reportTypeConfig = {
    lead_history_report: {
        id: 'lead_history_report',
        title: 'Lead History Report',
        headersSelectable: true,
    },
    lead_regular_report: {
        id: 'lead_regular_report',
        title: 'Lead Regular Report (Legacy)',
        headersSelectable: false,
    },
    call_attempt_report: {
        id: 'call_attempt_report',
        title: 'Call Attempt Report',
        headersSelectable: false,
    }
};

const reportTypes = {
    lead_history_report: {
        title: 'Lead History Report',
    },
    lead_regular_report: {
        title: 'Lead Regular Report (Legacy)',
    },
    call_attempt_report: {
        title: 'Call Attempt Report',
    },
    lead_live_report: {
        title: 'Lead Live Report',
    }
};

const ProjectReport = (props) => {

    const getDate = () => {
        return moment().toDate();
    };

    let emailRef = useRef()
    let submitBtnReport = useRef('')

    const [emailArray, setEmailArray] = useState([])
    const [reportSent, setReportSent] = useState(false)
    const [outcomesArrayToSend, setOutcomesArrayToSend] = useState([])
    const [reportError, setReportError] = useState({
        status: false,
        msg: ''
    })
    const [invalidEmailError, setinvalidEmailError] = useState(false)
    const [reportStartDate, setReportStartDate] = useState(getDate())
    const [reportEndDate, setReportEndDate] = useState(getDate())
    const [reportType, setReportType] = useState(reportTypeConfig.lead_history_report.id)
    const [headers, setHeaders] = useState([])
    const [selectedHeaders, setSelectedHeaders] = useState([])
    const [isDropdownDisabled, setIsDropdownDisabled] = useState(true)
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [reportRequests, setReportRequests] = useState([])
    const dropdownRef = useRef(null);
    const [pendingRequestsCount, setPendingRequestsCount] = useState(0)

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setMenuIsOpen(false);
        }
    };

    useEffect(() => {
        fetchReportRequests()
        fetchQueueCount()
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);


    useEffect(() => {
        const fetchAndSetHeaders = async () => {
            try {
                const headersFetched = await ApiActions.fetchNormalizedHeadersByProjectId(props.data.id)
                const groupedOptions = Object.keys(headersFetched).map(headerType => ({
                    label: headerType,
                    options: headersFetched[headerType].map(header => ({
                        category: headerType,
                        label: header,
                        value: header
                    }))
                }));

                const totalHeaderCount = groupedOptions && groupedOptions.flatMap(group => group.options).length ?
                    groupedOptions.flatMap(group => group.options).length : 0
                setHeaders(groupedOptions)
                // disable dropdown if no options are available
                setIsDropdownDisabled(totalHeaderCount <= 0 ? true : false)
            } catch (error) {
                console.error("Error fetching normalized headers:", error)
            }
        }

        fetchAndSetHeaders()
    }, [props.data.id])

    useEffect(() => {
        if (headers.length > 0) {
            setSelectedHeaders(headers.flatMap(group => group.options))
        }
    }, [headers])

    const CheckboxOption = (props) => {
        return (
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    readOnly
                    style={{ marginRight: 10 }}
                />
                {props.label}
            </components.Option>
        );
    };

    const CustomGroupHeading = (props) => {
        const groupLabel = props.children;
        const group = (headers || []).find(g => g.label === groupLabel);
        const groupOptions = group ? group.options : [];
        const selectedGroupOptions = groupOptions.filter(opt =>
            selectedHeaders.some(sel => sel.value === opt.value && sel.category === opt.category)
        );
        const isAllSelected = groupOptions.length > 0 && selectedGroupOptions.length === groupOptions.length;

        const handleGroupClick = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isAllSelected) {
                // Remove all options of this group from selectedHeaders
                setSelectedHeaders(prev => prev.filter(sel =>
                    !groupOptions.some(opt => opt.value === sel.value && opt.category === sel.category)
                ));
            } else {
                // Add all options of this group to selectedHeaders, preventing duplicates
                setSelectedHeaders(prev => {
                    const otherSelected = prev.filter(sel =>
                        !groupOptions.some(opt => opt.value === sel.value && opt.category === sel.category)
                    );
                    return [...otherSelected, ...groupOptions];
                });
            }
        };

        return (
            <components.GroupHeading {...props}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontWeight: 'bolder',
                    color: 'black',
                    padding: '8px 0px 8px 0px',
                    textTransform: 'none',
                }}>
                    <span style={{ textTransform: 'uppercase' }}>{props.children}</span>
                    <button
                        type="button"
                        onClick={handleGroupClick}
                        style={{
                            background: 'none',
                            border: 'none',
                            color: '#007bff',
                            cursor: 'pointer',
                            fontSize: '11px',
                            fontWeight: 'normal',
                            padding: '0 4px',
                            textTransform: 'none',
                            outline: 'none',
                        }}
                    >
                        {isAllSelected ? 'Unselect All' : 'Select All'}
                    </button>
                </div>
            </components.GroupHeading>
        );
    };

    const CustomMenuList = (props) => {
        const allOptions = headers.flatMap(group => group.options) || [];
        const isAllSelected = selectedHeaders.length === allOptions.length;
        const isSomeSelected = selectedHeaders.length > 0 && !isAllSelected;

        const handleSelectAll = (e) => {
            e.preventDefault();
            e.stopPropagation();
            if (isAllSelected) {
                setSelectedHeaders([]);
            } else {
                setSelectedHeaders(allOptions);
            }
        };

        return (
            <components.MenuList {...props}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 12px',
                    borderBottom: '1px solid #eee',
                    cursor: 'pointer',
                    userSelect: 'none',
                }} onClick={handleSelectAll}>
                    <input
                        type="checkbox"
                        checked={isAllSelected}
                        ref={el => {
                            if (el) {
                                el.indeterminate = isSomeSelected;
                            }
                        }}
                        readOnly
                        style={{ marginRight: 10, cursor: 'pointer' }}
                    />
                    <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#333' }}>
                        Select / Unselect All
                    </span>
                </div>
                {props.children}
            </components.MenuList>
        );
    };

    const totalHeaderCount = headers && headers.flatMap(group => group.options).length ?
        headers.flatMap(group => group.options).length : 0
    const selectHeaderCount = selectedHeaders && selectedHeaders.length > 0 ?
        selectedHeaders && selectedHeaders.length : 0

    const originalStartDate = props.data.startDate ? props.data.startDate && props.data.startDate.split('T')[0] : props.defaultStartDate ? props.defaultStartDate : ''
    const originalEndDate = props.data.endDate ? props.data.endDate && props.data.endDate.split('T')[0] : props.defaultEndDate ? props.defaultEndDate : ''
    let app;
    if (props.data && props.data.outcomes) {
        app = props.data.outcomes.map((item, id) => {
            return ({
                "id": id,
                "outcome": item.title
            })
        })
    }

    const [startDate, setStartDate] = useState(moment(props.data.defaultEndDate || moment()));
    const [endDate, setEndDate] = useState(moment(props.data.defaultEndDate || moment()));


    const addEmail = (email) => {

        if (!emailHelper.hasOnlyFutworkEmails([email])) {
            setinvalidEmailError(true)
            return
        }

        emailRef.current.value = ''
        const updateArray = [...emailArray, email]
        setEmailArray(updateArray)
    }

    const removeEmail = (idx) => {
        let updatedEmailArray = [...emailArray]
        updatedEmailArray.splice(idx, 1)
        setEmailArray([...updatedEmailArray])
    }

    const sendReport = async () => {
        let { id } = props.data;
        let dataToSend = {
            "teleproject": id,
            "startDate": moment(reportStartDate).format('YYYY-MM-DD'),
            "endDate": moment(reportEndDate).format('YYYY-MM-DD'),
            "outcomes": outcomesArrayToSend,
            "reportType": reportType
        }

        if (emailArray && emailArray.length > 0) {
            dataToSend.emails = JSON.stringify(emailArray);
        }

        if (reportTypeConfig[reportType].headersSelectable) {
            dataToSend.visibleHeaders = selectedHeaders.reduce((result, { category, value }) => {
                result[category] ? result[category].push(value) : result[category] = [value]
                return result
            }, {})
        }

        // Getting latest status of the report requests
        let reportRequests;
        try {
            reportRequests = await ApiActions.fetchLatestProjectReportRequests(id);
            setReportRequests(reportRequests);
        } catch (err) {
            console.error("Error fetching report requests:", err);
            submitBtnReport.current.stopLoading();
            return;
        }

        // Checking for pending requests raised by the user
        let authToken = localStorage.getItem("authToken");
        const userId = jwt_decode(authToken).base;
        const existingReport = reportRequests.find(reportRequest =>
            reportRequest.teleproject === dataToSend.teleproject &&
            reportRequest.status === "Pending" &&
            reportRequest.reportParams.userId === userId
        );

        if (existingReport) {
            setReportError({
                status: true,
                msg: 'A report request for this project is already pending. Please check the Report History for its status.'
            });
            return;
        }

        submitBtnReport.current.startLoading()

        let result = ''

        const checkIfReportSent = (result) => {
            if (result) setReportSent(true)
            else return false
        }

        try {
            result = await getProjectReports(dataToSend)
            checkIfReportSent(result)
        } catch (err) {
            console.error((err.response && err.response.data) || "Unexpected Error!")

            checkIfReportSent('')
            if (err && err.response && err.response.data && err.response.data.code === 'MUL_REP_REQ_ERR') {
                setReportError({
                    status: true,
                    msg: err.response.data.msg
                })
            }
            return true

        } finally {
            submitBtnReport && submitBtnReport.current && submitBtnReport.current.stopLoading()
            fetchReportRequests()
        }
    }

    const selectStyles = {
        control: provided => ({ ...provided, minWidth: 240, margin: 8 }),
        menu: () => ({ boxShadow: 'inset 0 1px 0 rgba(0, 0, 0, 0.1)' }),
    };

    const Svg = (p) => (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            focusable="false"
            role="presentation"
            {...p}
        />
    );
    const DropdownIndicator = () => (
        <div css={{ color: colors.neutral20, height: 2, width: 32 }}>
            <Svg>
                <path
                    d="M16.436 15.085l3.94 4.01a1 1 0 0 1-1.425 1.402l-3.938-4.006a7.5 7.5 0 1 1 1.423-1.406zM10.5 16a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11z"
                    fill="currentColor"
                    fillRule="evenodd"
                />
            </Svg>
        </div>
    );

    const getOutcomes = () => {
        let result = props.data.outcomes && props.data.outcomes.length > 0 ? props.data.outcomes.map((outcome, idx) => {
            return {
                id: idx, value: outcome.title, label: `${outcome.title}${outcome.allowed === 'none' ? ' (Turned off) ' : ''}`.trim(),
                disabled: outcome.allowed === 'none' ? true : false
            }
        }) : []
        return result
    }

    const fetchReportRequests = async () => {
        try {
            const reportRequests = await ApiActions.fetchLatestProjectReportRequests(props.data.id)
            setReportRequests(reportRequests)
            if (reportError.status) {
                setReportError({
                    status: false,
                    msg: ''
                })
            }
        } catch (error) {
            console.error("Error fetching report requests:", error)
        }
    }

    const cancelReportRequest = async (requestId) => {
        try {
            await ApiActions.cancelProjectReportRequest(requestId)
            fetchReportRequests()
        } catch (error) {
            console.error("Error cancelling report request:", error)
        }
    }

    const fetchQueueCount = async () => {
        try {
            const queueCount = await ApiActions.fetchProjectReportQueueCount()
            setPendingRequestsCount(queueCount.pending_reports)
        } catch (error) {
            console.error("Error fetching queue count:", error)
        }
    }

    const columns = [
        {
            Header: 'Type',
            accessor: "reportParams.reportType",
            Cell: ({ value }) => `${reportTypes[value] ? reportTypes[value].title : 'NA'}`,
            width: "10%",
            disableSortBy: true
        },
        {
            Header: 'Generated On',
            accessor: 'createdAt',
            Cell: ({ value }) => (
                <div>
                    <span>{moment(value).format("DD-MM-YYYY")}</span>
                    <span>{moment(value).format("hh:mm A")}</span>
                </div>
            ),
            width: "7%",
            disableSortBy: true
        },
        {
            Header: 'Report Period',
            Cell: ({ cell }) => {
                const value = cell.row.original
                if (value.reportParams && value.reportParams.startDate && value.reportParams.endDate) {
                    return <div>
                        <span><strong>From:</strong> {value.reportParams.startDate}</span>
                        <span><strong>To:</strong> {value.reportParams.endDate}</span>
                    </div>
                } else {
                    return ''
                }
            },
            width: "10%",
            disableSortBy: true
        },
        {
            Header: 'Status',
            accessor: 'status',
            Cell: ({ cell }) => {
                if (cell.row.original.status === 'Pending') {
                    return <span style={{color: 'orange', fontWeight: 'bold'}} className='inprogress'>Pending</span>
                } else if (cell.row.original.status === 'Completed'){
                    return <span style={{color: 'green', fontWeight: 'bold'}} className='completed'>Completed</span>
                } else if (cell.row.original.status === 'Cancelled'){
                    return <span style={{color: 'red', fontWeight: 'bold'}} className='completed'>Cancelled</span>
                }
            },
            width: "2%",
            disableSortBy: true
        },
        {
            Header: 'Role',
            accessor: "reportParams.role",
            width: "2%",
            disableSortBy: true
        },
        {
            Header: 'Actions',
            Cell: ({ cell }) => {
                const value = cell.row.original
                if (value && value.reportParams && value.reportParams.reportUrl) {
                    return <div>
                        <a href={value.reportParams.reportUrl} target="_blank" rel="noopener noreferrer">
                            <img src={require('../../../assets/images/download.png')} alt="download" />
                        </a>
                    </div>
                } else if (value.status === 'Pending') {
                    if (moment() >= moment(value.createdAt).add('10', 'minutes')) {
                        return <div>
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    cancelReportRequest(value.id)
                                }}
                            >
                                <span style={{ color: 'red', fontWeight: 'bold' }} className='completed'>Cancel</span>
                            </a>
                        </div>
                    } else {
                        return <div><img src={require("../../../assets/images/hourglass-512.webp")} style={{cursor: 'default'}}/></div>
                    }
                } else if (value.status === 'Cancelled') {
                    return ''
                } else {
                    return 'No Data'
                }
            },
            width: "1%",
            disableSortBy: true
        }
    ]

    return (
        <div className="project-report-modal">
            <div className='report-download'>
                <div className='section-title'>Generate Report</div>
                <div className='report-type'>
                    <span className='heading'>Report type: </span>
                    <DropdownButton
                        bsSize="small"
                        title={reportTypeConfig[reportType].title}
                        id="dropdown-size-small"
                    >
                        {Object.values(reportTypeConfig).map(report => (
                            <MenuItem
                                key={report.id}
                                eventKey={report.id}
                                onSelect={(e) => {
                                    setReportEndDate(getDate())
                                    setReportStartDate(getDate())
                                    setReportType(e)
                                }}>{report.title}</MenuItem>
                        ))}
                    </DropdownButton>
                </div>
                {
                    reportTypeConfig[reportType].headersSelectable ?
                        <div ref={dropdownRef}>
                            <div className='report-type'>
                                <span className='heading'>Choose headers to display in the report</span>
                            </div>
                            <div className="headers-for-report">
                                <DropdownButton
                                    disabled={isDropdownDisabled ? true : false}
                                    title={isDropdownDisabled ? `No Headers Available` : `${selectHeaderCount} / ${totalHeaderCount} headers selected`}
                                >
                                    <Select
                                        autoFocus
                                        backspaceRemovesValue={false}
                                        components={{
                                            Option: CheckboxOption,
                                            GroupHeading: CustomGroupHeading,
                                            MenuList: CustomMenuList,
                                            // Input: CustomInput,
                                            DropdownIndicator,
                                            IndicatorSeparator: null,
                                        }}
                                        controlShouldRenderValue={false}
                                        hideSelectedOptions={false}
                                        isClearable={false}
                                        menuIsOpen
                                        onChange={(selectedOptions) => {
                                            setSelectedHeaders(selectedOptions);
                                        }}
                                        options={headers}
                                        placeholder="Search..."
                                        className="react-select-container"
                                        classNamePrefix="react-select"
                                        styles={selectStyles}
                                        tabSelectsValue={false}
                                        value={selectedHeaders}
                                        isDisabled={isDropdownDisabled} // Disable dropdown if no headers
                                        isSearchable={!isDropdownDisabled} // Disable search input if no headers
                                        isMulti
                                    />
                                </DropdownButton>
                            </div>

                        </div> : ''
                }
                <div className={styles.email_section}>
                    <div className={styles.pill_wrapper}>
                        {emailArray.map((email, idx) => {
                            return <div className={styles.pill} key={idx}>
                                {email}
                                <div className={styles.del_icon}>
                                    <img src={DeleteIcon} alt='delete-icon' onClick={() => removeEmail(idx)} />
                                </div>
                            </div>;
                        })}
                    </div>
                    <div className={styles.email_field}>
                        <div className={styles.email_field_row}>
                            <div className={styles.email_text}>
                                <FormGroup>
                                    <input type='email' placeholder="Enter email address & press enter" name="email" ref={emailRef} onKeyDown={(e) => {
                                        if (e.key === 'Enter' && e.target.value !== '')
                                            addEmail(e.target.value)
                                    }} onChange={(e) => { setinvalidEmailError(false) }} />
                                </FormGroup>
                            </div>
                            <img src={PlusIcon} alt='plus_icon' onClick={(e) => {
                                if (emailRef.current.value !== '') {
                                    addEmail(emailRef.current.value)
                                }
                            }} />
                        </div>
                        {invalidEmailError ? <div className={styles['error-message']}>Invalid email domain. Please use your futwork.com email.</div> : ''}
                    </div>
                </div>
                <div>
                    <div className="date-report">
                        <div name="startDate" id="startdate">
                            <Datepicker
                                dateFormat="dd/MM/yyyy"
                                selectedDate={reportStartDate}
                                placeholderText='Select start date'
                                minDate={originalStartDate && moment(originalStartDate).isValid() ? moment(originalStartDate).toDate() : moment().toDate()}
                                // minDate={moment().subtract(90,'days').toDate()} // can go back upto 3 months back
                                // minDate={moment(orginalStartDate).toDate()}
                                //the start date range for a historic report can be fetched from the 1st Jan of the current year
                                // minDate={moment().startOf('year').toDate()}
                                maxDate={moment().toDate()}
                                onChange={(date) => {
                                    setReportStartDate(date);
                                    let endDate = moment.min([moment(), moment(originalEndDate), moment(date).add(90, 'days')]).toDate()
                                    setReportEndDate(endDate);
                                }}
                            />
                            <div className="info">Start Date</div>
                        </div>
                        <div className="endDate" id="enddate">
                            <Datepicker
                                dateFormat="dd/MM/yyyy"
                                selectedDate={reportEndDate}
                                placeholderText='Select start date'
                                minDate={ moment.max([moment(reportStartDate), moment(originalStartDate)]).toDate() }
                                // maxDate={moment().toDate() > moment(originalEndDate).toDate() ? moment(originalEndDate).toDate() : moment().toDate()}
                                // maxDate={moment().toDate() <= moment(originalEndDate).toDate() ?
                                // moment(reportStartDate).add(90,'days').toDate() : moment(originalEndDate).toDate()}
                                //the max date range for the end date is 3 months in case of historic report
                                maxDate={moment().toDate()}
                                onChange={date => {
                                    setReportEndDate(date)
                                    if (!reportStartDate) setReportStartDate(moment(date).subtract(30, 'days').toDate())
                                }}
                            />
                            <div className="info">End Date</div>
                        </div>
                    </div>
                    <p>
                        Remember to press the green plus-icon before you click on 'Send Report'
                        <br />
                        If you enter no email the report will be sent to
                        the default email list.
                    </p>
                </div>
                <div className="multiselect-dropdown">
                    <div style={{ minWidth: '180px' }}>
                        <Select options={getOutcomes()}
                            placeholder="Select an outcome"
                            isMulti
                            name="outcome-linked"
                            classNamePrefix="select"
                            onChange={(e) => {
                                let value = e && e.map((item) => item.value)
                                setOutcomesArrayToSend(value ? value : [])
                            }}
                            isSearchable={true}
                            isOptionDisabled={(option) => option.disabled}
                        />
                    </div>
                </div>
                <div style={{ width: "100%", display: 'flex', justifyContent: 'center' }}>
                    {reportSent ? <div className="success-banner">
                        Preparing your report - you will receive it on email shortly.Here is some <a href="http://www.allolo.ru/" target="_blank" rel="noopener noreferrer">
                            Relaxing Music
                        </a> to listen to till then.
                        <FrappButton className="submit" id="download-report" type="submit" disabled={emailArray && emailArray.length > 0 ? false : true}
                            handler={() => setReportSent(false)}
                            ref={submitBtnReport}
                        >
                            Send Again
                        </FrappButton>
                    </div> : reportError.status ? <div className={styles['error-message']}>{reportError.msg}</div> : <FrappButton className="submit" id="download-report" type="submit"
                        disabled={
                            !(
                                emailArray && emailArray.length > 0 &&
                                startDate !== ('' || null) &&
                                endDate !== ('' || null) &&
                                (!reportTypeConfig[reportType].headersSelectable || (selectedHeaders && selectedHeaders.length > 0))
                            )
                        }
                        handler={() =>
                            sendReport()
                        }
                        ref={submitBtnReport}
                    >
                        Send Report
                    </FrappButton>}
                </div>
                <ToastContainer draggable={true} />
            </div>
            <div className='report-history'>
                <div className='section-title'>
                    <div className='title'>Recent Report Requests</div>
                    <div className='refresh' onClick={() => {
                        fetchReportRequests();
                        fetchQueueCount();
                    }}>
                        <img src={require('../../../assets/images/Icons_refresh.svg')} />
                    </div>
                </div>
                <div className='pending-reports-count'>
                    <span style={{marginRight: '10px'}}><img src={require('../../../assets/images/exclamation.svg')}/></span><b> {pendingRequestsCount} report(s) are waiting to be generated.</b>
                </div>
                <div>
                    <Table
                        columns={columns}
                        data={reportRequests}
                    // totalCount={total}
                    // limit={limit}
                    // currentPage={currentPage}
                    // setCurrentPage={setCurrentPage}
                    // loading={loading}
                    // sortChange={sortChange}
                    // filterChange={filterChange}
                    // searchBy='project id or title'
                    // isGlobalFilter={true}
                    // search={search}
                    />
                </div>
            </div>
        </div>
    )
}

export default ProjectReport